<script setup lang="ts">
    defineProps<{
        title?: string | null;
        storyId?: string;
        hasExtraPadding?: boolean;
    }>();
</script>

<template>
    <div
        class="advantage-list"
        :class="hasExtraPadding ? '--extra-padding' : ''"
    >
        <h3 v-if="title">{{ title }}</h3>
        <ModalContent
            v-if="storyId"
            :story-id="storyId"
        />
        <slot name="cta"></slot>
    </div>
</template>

<style>
    @import '~/assets/scss/basics/advantages.scss';
</style>
